module.exports = __webpack_public_path__ + "assets/Deepbite.c94c3835ee0efcfa3486bbabe4db8908.svg";